import { render, staticRenderFns } from "./AddMultipleForms.vue?vue&type=template&id=3cf03c86&"
import script from "./AddMultipleForms.vue?vue&type=script&lang=js&"
export * from "./AddMultipleForms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports